import { nameof } from "@libs/utils/name-of.utils.ts";
import {
  maxLength,
  predicate,
  required
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { ClaimDischargeFormValues } from "../types/dischargeFormValues.type.ts";

export class ClaimDischargeFormValidator extends Validator<ClaimDischargeFormValues> {
  constructor(haveMutipleDisciplines: boolean) {
    super();

    this.forField(nameof("dischargeDate"), required());
    this.forField(nameof("discharger"), required());
    this.forField(nameof("dischargeOutcome"), required());

    this.forField(nameof("notes"), maxLength(255));

    // businessRoles is required if there are mutiple disciplines
    this.forField(
      nameof("businessRoles"),
      predicate(() => haveMutipleDisciplines, required())
    );
  }
}
